// Dawn's button blocks (image-banner, rich-text, multicolumn) have no
// "open in new tab" setting, so outbound links are upgraded here instead.
const HAL_EXTERNAL_HOSTS = ['livepocket.jp', 'kanachu.co.jp'];

// The social icons are the same question by a different route: Dawn renders
// them from theme settings in both social-icons.liquid and
// header-drawer.liquid — eighteen anchors between them — and leaves them in
// the same tab, which now reads as inconsistent beside the outbound links
// above. Matching the class covers both files, and any network added later.
const HAL_EXTERNAL_SELECTORS = ['.list-social__link'];

document.addEventListener('DOMContentLoaded', () => {
  const selector = HAL_EXTERNAL_HOSTS.map((h) => `a[href*="${h}"]`)
    .concat(HAL_EXTERNAL_SELECTORS)
    .join(', ');
  document.querySelectorAll(selector).forEach((link) => {
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
  });
});
